import React from 'react';

const LastPage = (): JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 0c.256 0 .512.098.707.293l7 7a.999.999 0 0 1 0 1.414l-7 7a.999.999 0 1 1-1.414-1.414L10.586 8 4.293 1.707A.999.999 0 0 1 5 0z"
    />
    <path d="M15 1v14" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default LastPage;
